module.exports = __webpack_public_path__ + "static/media/Política reclamaciones-1.356e92d0.png";